export const USD_TO_USD_TO_SOCS = 1.5;

export const SEVEN_DAYS_IN_MS = 7 * 24 * 60 * 60 * 1000;

export const MIN_AMOUNT_IN_USD_PER_WALLET = 75;
export const MAX_AMOUNT_IN_USD_PER_WALLET = 50000;
